<ng-container *ngIf="hasList; else legacy">
  <ul class="sectionreferences__list">
    <li *ngFor="let reference of references" class="sectionreferences__item"
      [class.sectionreferences__item--heading]="reference.is_heading">
      <strong *ngIf="reference.is_heading; else citation">{{ reference.title }}</strong>
      <ng-template #citation>
        <a *ngIf="reference.url; else titleOnly" [href]="reference.url" target="_blank"
          rel="noopener noreferrer">{{ reference.title || reference.url }}</a>
        <ng-template #titleOnly>{{ reference.title }}</ng-template>
      </ng-template>
    </li>
  </ul>
  <p *ngIf="checkedOn" class="sectionreferences__checked">Last checked {{ checkedOn | date:'MMMM yyyy' }}</p>
</ng-container>
<ng-template #legacy>
  <div class="sectionreferences__legacy" [innerHTML]="legacyReferences"></div>
</ng-template>
